var toString = require('../lang/toString');
    /**
     * "Safer" String.toUpperCase()
     */
    function upperCase(str){
        str = toString(str);
        return str.toUpperCase();
    }
    module.exports = upperCase;




//////////////////
// WEBPACK FOOTER
// ./node_modules/mout/string/upperCase.js
// module id = 719
// module chunks = 1